$(function () {
  var pre_ref = document.referrer;
  const LP_EX_URL = "https://geek-salon.com/webex";
  const addExMessage =
    "===WebExpertコースの紹介ページを見て申し込みました。(このメッセージは自動で記述されています)===";

  if (LP_EX_URL == pre_ref) {
    document.getElementById("landing_page_user_trial_memo").textContent =
      addExMessage;
  }

  if ($("form .landing_page_user_trial_area_id").length < 1) return;
  $(".form-input-box input, .form-input-box select").each(function () {
    updateInputBox(this, false);
  });
  $(".form-input-box input, .form-input-box select").on("input", function () {
    updateInputBox(this, true);
  });
  updateBriefingTrialLabels();
  let briTrials = [];
  $(".bri-trials .trial-id-radios").each(function () {
    briTrials.push(this);
  });
  let expTrials = [];
  $(".exp-trials select option").each(function () {
    expTrials.push(this);
  });
  let $area = $(
    "select[name='landing_page_user_trial[area_id]'] option:selected"
  ).val();
  let $course =
    $(
      "input[type='radio'][name='landing_page_user_trial[course]']:checked"
    ).val() || "";
  let $trialID = "";
  let trialPage = 0;
  updateTrials();
  $(".pagination-btn.next").on("click", function () {
    if ($(this).hasClass("active")) {
      trialPage++;
      updateBriefingTrials();
    }
  });
  $(".pagination-btn.previous").on("click", function () {
    if ($(this).hasClass("active")) {
      trialPage--;
      updateBriefingTrials();
    }
  });

  $("select[name='landing_page_user_trial[area_id]']").on(
    "change",
    function () {
      $area = this.value;
      updateTrials();
    }
  );

  $("input[type='radio'][name='landing_page_user_trial[course]']").on(
    "change",
    function () {
      $course = this.value;
      updateTrials();
    }
  );

  $(".exp-trials select").on("change", function () {
    $trialID = this.value;
    checkRequiredInputs();
  });

  $("select[name='landing_page_user_trial[from_where]']").on(
    "change",
    function () {
      let $fromWhere = this.value;
      if ($fromWhere.includes("紹介")) {
        $(".form-block.introducer").show();
      } else {
        $(".form-block.introducer").hide();
      }
    }
  );

  $(".form-block.memo textarea").on("input", function () {
    let memoCount = $(this).val().length;
    $(".memo-count").text(`${memoCount}/500`);
  });

  $(".scroll-terms").scroll(function () {
    let scrollHeight = $(".scroll-terms").get(0).scrollHeight;
    let scrollPosition =
      $(".scroll-terms").height() + $(".scroll-terms").scrollTop();
    if ((scrollHeight - scrollPosition) / scrollHeight < 0.03) {
      $('input[name="landing_page_user_trial[agreement]"]').removeAttr(
        "disabled"
      );
      $(".require-reading").hide();
    }
  });

  $("input[type='checkbox'][name='landing_page_user_trial[agreement]']").on(
    "change",
    function () {
      if (
        $(
          ".agreement input[type='checkbox'][name='landing_page_user_trial[agreement]']"
        ).prop("checked")
      ) {
        $(".agreement").addClass("success");
        $(".agreement").find(".error-message").remove();
      } else {
        $(".agreement").removeClass("success");
        if ($(".agreement").find(".error-message").length == 0) {
          $(".agreement").prepend(
            "<div class='error-message'>個人情報保護方針に同意してください</div>"
          );
        }
      }
      checkRequiredInputs();
    }
  );

  ////////////////////////////// functions //////////////////////////////

  function updateTrials() {
    $(".bri-trials").hide();
    $(".bri-trials input").prop("disabled", true);
    $(".exp-trials").hide();
    $(".exp-trials select").prop("disabled", true);
    $(".course").hide();
    $(".trial .block-title").text("参加日程");
    $trialID = "";

    $(".bri-trials").show();
    $(".bri-trials input").prop("disabled", false);
    $(".trial .block-title").text("参加日程");
    trialPage = 0;
    updateBriefingTrials();

    checkRequiredInputs();
  }

  function updateBriefingTrials() {
    $("input[name='landing_page_user_trial[trial_id]']:checked").prop(
      "checked",
      false
    );
    $(".trial-id-radios").remove();
    $(".blank-trial-radios").remove();
    $(".trials-caution").remove();
    let trialCount = 0;
    $(".pagination-btn.previous").removeClass("active");
    $(".pagination-btn.next").removeClass("active");
    let blankInputs = [];
    if ($area == "") {
      blankInputs.push("最寄りの教室");
    }
    if (blankInputs.length > 0) {
      $(".bri-trials .radio_items").append(
        "<div class='trials-caution'>先に" +
          blankInputs.join("･") +
          "を選択してください</div>"
      );
    } else {
      for (let i = 0; i < briTrials.length; i++) {
        let $trial = $(briTrials[i]).find("input");
        if ($trial.data("area-id") == $area || $trial.val() == "") {
          trialCount++;
          if (trialCount > 10 * trialPage) {
            if (trialCount - 10 * trialPage > 10) {
              $(".pagination-btn.next").addClass("active");
            } else {
              $(".bri-trials .radio_items").append(briTrials[i]);
              $(briTrials[i]).show();
            }
          }
        }
      }
      if (trialPage > 0) {
        $(".pagination-btn.previous").addClass("active");
      }
      if (trialCount == 0) {
        $(".bri-trials .radio_items").append(
          "<div class='trials-caution'>参加可能な日程がありません</div>"
        );
      }
    }
    if (trialCount == 0) {
      $(".pagination-index").text("1/1");
    } else {
      $(".pagination-index").text(
        (trialPage + 1).toString() +
          "/" +
          (1 + (trialCount - 1) / 10).toString()
      );
    }
    for (let i = trialCount - 10 * trialPage; i < 10; i++) {
      $(".landing_page_user_trial_trial .radio_items").append(
        "<div class='blank-trial-radios'></div>"
      );
    }
    $("#landing_page_user_trial_trial_id").val("");

    $(".trial-id-radios label").on("click", function () {
      $trialID = $(this).parents(".trial-id-radios").find("input").val();
      checkRequiredInputs();
    });
  }

  function updateBriefingTrialLabels() {
    dow = ["日", "月", "火", "水", "木", "金", "土"];
    let $trials = $(".trial-id-radios");
    for (let i = 0; i < $trials.length; i++) {
      $trial = $($trials[i]);
      if ($trial.find("input").data("date") != null) {
        date = $trial.find("input").data("date").split("/");
        $trial.find("label").text("");
        $trial
          .find("label")
          .append(
            "<div class='trial-day'>" +
              dow[parseInt(date[3])] +
              "</div>" +
              "<div class='trial-date'>" +
              date[1] +
              "/" +
              date[2] +
              "</div>" +
              "<div class='trial-start'>" +
              date[4] +
              ":" +
              date[5] +
              "~" +
              "</div>"
          );
      }
    }
  }

  function updateExperienceTrials() {
    let $select = $(".exp-trials select");
    $select.find("option").remove();
    $(".trials-caution").remove();

    let blankInputs = [];
    if ($area == "") {
      blankInputs.push("最寄りの教室");
    }
    if ($course == "") {
      blankInputs.push("参加コース");
    }
    if (blankInputs.length > 0) {
      $(".exp-trials").prepend(
        "<div class='trials-caution'>先に" +
          blankInputs.join("･") +
          "を選択してください</div>"
      );
    } else {
      for (let i = 0; i < expTrials.length; i++) {
        let $trial = $(expTrials[i]);
        if (
          ($trial.data("area-id") == $area && $trial.data("course")) ==
            $course ||
          $trial.val() == ""
        ) {
          $select.append($trial);
        }
      }
      $select.val("");
    }
    let $inputBox = $select.parents(".form-input-box");
    $inputBox.removeClass("success error");
    $inputBox.find(".error-message").remove();
  }

  function updateInputBox($input, loadError) {
    $inputBox = $($input).parents(".form-input-box");
    if ($input.value) {
      $inputBox.addClass("has-input");
    } else {
      $inputBox.removeClass("has-input");
    }
    if (!$inputBox.hasClass("valid")) {
      return;
    }

    if ($inputBox.hasClass("valid-blank")) {
      success = $input.value;
      let blockTitle = $inputBox
        .parents(".form-block")
        .find(".block-title")
        .text();
      errorMessage = `${blockTitle}を入力してください`;
    }
    if ($inputBox.hasClass("valid-select")) {
      success = $input.value;
      let blockTitle = $inputBox
        .parents(".form-block")
        .find(".block-title")
        .text();
      errorMessage = `${blockTitle}を選択してください`;
    }
    if ($inputBox.hasClass("valid-email")) {
      success = $input.value.includes("@");
      errorMessage = "メールアドレスが正しくありません";
    }
    if ($inputBox.hasClass("valid-phone")) {
      success = $input.value.match(/^0([5789]0\d{8}|[1-9]{2}\d{7})$/);
      errorMessage = "電話番号が正しくありません";
    }

    $inputBox.removeClass("success");
    $inputBox.removeClass("error");
    $inputBox.find(".error-message").remove();
    if (success) {
      $inputBox.addClass("success");
    } else if (loadError) {
      $inputBox.addClass("error");
      $inputBox.append(`<div class='error-message'>${errorMessage}</div>`);
    }
    checkRequiredInputs();
  }
  let isShowDialog = true;
  function checkRequiredInputs() {
    let validationCount = $(".valid").length;
    let successCount = $(".success").length;
    if (validationCount == successCount && $trialID) {
      isShowDialog = false;
      $("input[type='submit']").prop("disabled", false);
      $(".disabled-submit-message").hide();
      $("#trials-submit").click(() => {
        $(".loading").addClass("active");
        $(".loading-message").text(
          "処理には時間がかかる場合がございます。しばらくお待ちください"
        );
      });
    } else {
      $("input[type='submit']").prop("disabled", true);
      $(".disabled-submit-message").show();
    }
  }

  function noticeAlertWhenLeaveForm() {
    window.addEventListener("beforeunload", (event) => {
      if (isShowDialog) {
        event.preventDefault();
        event.returnValue = "本当にページを離れてもいいですか？";
      }
    });
  }
  noticeAlertWhenLeaveForm();
});
